// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import bgImg from "./assets/blog/background.jpeg";

// Page Components
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import TeamsPage from "./pages/TeamsPage";
import CDLRosterPage from "./pages/CDLRosterPage";
import ValorRosterPage from "./pages/ValorRosterPage";
import CreatorsRosterPage from "./pages/CreatorsRosterPage";
import CreatorsPage from "./pages/CreatorsPage";
import FemaleRosterPage from "./pages/FemaleRosterPage";
import U18RosterPage from "./pages/U18RosterPage";
import GraduatesPage from "./pages/GraduatesPage";
import WarzoneRosterPage from "./pages/WarzoneRosterPage";
import PlayerProfilePage from "./pages/PlayerProfilePage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import MatchesPage from "./pages/MatchesPage";
import NewsPage from "./pages/NewsPage";
import ShopPage from "./pages/ShopPage";
import ContactPage from "./pages/ContactPage";
import JoinPage from "./pages/JoinPage";
import BracketPage from "./pages/BracketPage";
import AdminPage from "./pages/AdminPage";
import SpectatorView from "./pages/DraftWars/SpectatorView";
import CaptainRoom from "./pages/DraftWars/CaptainRoom";

// Layout wrapper component
function Layout({ children }) {
  return (
    <div className="min-h-screen bg-black flex flex-col relative">
      {/* Faded global background */}
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.12,
        }}
      />
      <Navbar />
      <main className="flex-1 pt-[72px] relative z-10">
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <Router basename="/">
      <Routes>
        {/* Admin — own full-page layout, no public Navbar/Footer */}
        <Route path="/admin" element={<AdminPage />} />
        {/* Draft Wars captain rooms — no nav/footer, full-screen experience */}
        <Route path="/draft-wars/c/:token" element={<CaptainRoom />} />

        {/* All public pages — wrapped in Layout */}
        <Route path="*" element={
          <Layout>
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/roster" element={<TeamsPage />} />
              <Route path="/roster/team/cdl" element={<CDLRosterPage />} />
              <Route path="/roster/team/valor" element={<ValorRosterPage />} />
              <Route path="/roster/team/creators" element={<CreatorsRosterPage />} />
              <Route path="/roster/team/female" element={<FemaleRosterPage />} />
              <Route path="/roster/team/u18" element={<U18RosterPage />} />
              <Route path="/roster/team/graduates" element={<GraduatesPage />} />
              <Route path="/roster/team/warzone" element={<WarzoneRosterPage />} />
              <Route path="/roster/:playerId" element={<PlayerProfilePage />} />
              <Route path="/creators" element={<CreatorsPage />} />
              <Route path="/announcements" element={<AnnouncementsPage />} />
              <Route path="/matches" element={<MatchesPage />} />
              <Route path="/events" element={<BracketPage />} />
              <Route path="/bracket" element={<BracketPage />} />
              <Route path="/draft-wars" element={<SpectatorView />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/join" element={<JoinPage />} />

              {/* 404 Fallback */}
              <Route path="*" element={
                <div className="min-h-[60vh] flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-6xl font-black text-red-600 mb-4">404</h1>
                    <p className="text-xl text-gray-400 mb-8">Page not found</p>
                    <a
                      href="/"
                      className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wide rounded transition-colors"
                    >
                      Go Home
                    </a>
                  </div>
                </div>
              } />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
